// extracted by mini-css-extract-plugin
export var addButton = "_52-d";
export var bullets = "_52-e";
export var compact = "_52-2";
export var container = "_52-j";
export var extendedWarrantyModal = "_52-f";
export var learn = "_52-l";
export var learnMore = "_52-g";
export var offeringOption = "_52-3";
export var offeringPrice = "_52-8";
export var offeringSubtitle = "_52-7";
export var offeringTitle = "_52-6";
export var offeringsContainer = "_52-0";
export var pdpTilesBackground = "_52-n";
export var plan = "_52-m";
export var regular = "_52-1";
export var remove = "_52-k";
export var seeDetailsIcon = "_52-i";
export var seeDetailsLink = "_52-h";
export var selectedOption = "_52-4";
export var shieldIcon = "_52-b";
export var shieldIconCompact = "_52-c";
export var subtitle = "_52-a";
export var title = "_52-9";
export var unselectedOption = "_52-5";